import React, { useRef, useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import { convertTimeNumeric } from "../../../lib/helpers/convertTime";
import { useNavigate } from "react-router-dom";

import "./Table.css";
import {
  updateRecent,
  setActiveProject,
  addFavorite,
  editProject,
  saveAs,
  deleteProject,
} from "../../../redux/actions/Projects";

const Table: React.FC<{
  projectList: any;
  handleClick: any;
  setProjectClicked: any;
  openDeleteM: any;
  setSearchText: any;
  style: any;
  activeProject: any;
  setActiveProject: (project: any) => void;
  updateRecent: (projectId: string) => void;
  addFavorite: (projectId: string) => void;
  editProject: (project: any) => void;
  saveAs: (project: any) => void;
  deleteProject: (project: any) => void;
  adminFolderState: boolean;
  sideOption: string;
  allUsers: any;
}> = ({
  projectList,
  handleClick,
  setProjectClicked,
  openDeleteM,
  setSearchText,
  style,
  activeProject,
  setActiveProject,
  updateRecent,
  addFavorite,
  editProject,
  saveAs,
  deleteProject,
  adminFolderState,
  sideOption,
  allUsers,
}) => {
  const [tableRowMenu, setTableRowMenu] = useState(false) as any;
  const [projectHover, setProjectHover] = useState() as any;
  const [xPosition, setXPosition] = useState(0) as any;
  const [yPosition, setYPosition] = useState(0) as any;
  const [viewOption, setViewOption] = useState(
    sideOption === "Feedback" ? "current" : "all"
  ) as any;
  const navigate = useNavigate();

  const openMenu = () => {
    setTableRowMenu(true);
  };

  const openProject = () => {
    updateRecent(activeProject.projectId);
    navigate("/project");
  };

  const addFavoriteProject = () => {
    addFavorite(activeProject.projectId);
    setActiveProject(null);
  };

  const editNameTitle = () => {
    editProject(activeProject);
    setActiveProject(null);
  };

  const saveAsNew = () => {
    saveAs(activeProject);
    setActiveProject(null);
  };

  const goDelete = () => {
    deleteProject(activeProject);
    setActiveProject(null);
  };

  const handleReportClick = () => {
    // if (
    //   !reportingList.find((item) => item.projectId === activeProject.projectId)
    // ) {
    //   addReportList(activeProject, user.oid);
    // }
    // setProjectToReport(activeProject);
    navigate("/stepone");
  };

  const getProjectCreator = (item) => {
    let creator = allUsers.filter((users) => item === users.oid);
    return creator[0].name;
  };

  return (
    <div>
      <select
        value={viewOption}
        name="allProjectOption"
        id="allProjectOption"
        style={{
          marginLeft: "4vw",
          width: "80px",
          height: "25px",
          marginTop: "20px",
          opacity: adminFolderState ? 1 : 0,
          cursor: adminFolderState ? "pointer" : "default",
        }}
        onChange={(e) => setViewOption(e.target.value)}
      >
        {sideOption === "Feedback" ? (
          <>
            <option value="current">Current</option>
            <option value="archived">Archived</option>
          </>
        ) : (
          <>
            <option value="all">All</option>
            <option value="current">Current</option>
            <option value="deleted">Deleted</option>
          </>
        )}
      </select>
      <div
        style={{
          marginLeft: "4vw",
          marginTop: "40px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="tableHeaders"
          style={{
            display: "flex",
            flexDirection: "row",
            borderBottom: "1.5px solid black",
            height: "5.5vh",
          }}
        >
          <div
            style={{
              width: "22vw",
            }}
          >
            <p className="responsiveTableFont">Project</p>
          </div>
          <div
            style={{
              width: "20vw",
            }}
          >
            <p className="responsiveTableFont">Owner</p>
          </div>
          <div
            style={{
              width: "7vw",
            }}
          >
            <p className="responsiveTableFont">Shared With</p>
          </div>
          <div
            style={{
              width: "7vw",
            }}
          >
            <p className="responsiveTableFont">Last Modified</p>
          </div>
          <div
            style={{
              width: "12vw",
            }}
          >
            <p className="responsiveTableFont">Date Created</p>
          </div>
          <div
            style={{
              width: "1vw",
            }}
          ></div>
        </div>
        <div
          style={{
            overflowY: "auto",
            maxHeight: "45vh",
          }}
        >
          {/* // .sort((a: any, b: any) => Number(a.modelId) - Number(b.modelId))
            // ? */}
          {projectList.map((item: any, index: number) => (
            <div
              key={index}
              // onDoubleClick={() => {
              //   setActiveProject(item);
              //   updateRecent(item.projectId);
              //   navigate("/project");
              // }}
              // onMouseOver={() => {
              //   setProjectHover(item.name);
              //   setProjectClicked(item.name);
              // }}
              onMouseOver={() => {
                setActiveProject(item);
                setProjectHover(item.projectId);
                // setProjectClicked(item.name);
              }}
              onMouseOut={() => {
                // setStarColor(isFavorite ? style.colors.primaryBlue : style.colors.grey5);
                if (!tableRowMenu) {
                  setTableRowMenu(false);
                  setActiveProject(null);
                  setProjectHover(false);
                }
              }}
              className="tableRowData"
              style={{
                display: "flex",
                flexDirection: "row",
                maxHeight: "9vh",
              }}
            >
              <div
                style={{
                  width: "22vw",
                }}
              >
                <p className="responsiveTableFont">{item.name}</p>
              </div>
              <div
                style={{
                  width: "20vw",
                }}
              >
                <p className="responsiveTableFont">
                  {getProjectCreator(item.creatorUserId)}
                </p>
              </div>
              <div
                style={{
                  width: "7vw",
                }}
              >
                <p className="responsiveTableFont"></p>
              </div>
              <div
                style={{
                  width: "7vw",
                }}
              >
                <p className="responsiveTableFont">
                  {convertTimeNumeric(item.createdDate)}
                </p>
              </div>
              <div
                style={{
                  width: "12vw",
                  display: "flex",
                }}
              >
                <p className="responsiveTableFont">
                  {convertTimeNumeric(item.createdDate)}
                </p>
                {/* todo revisit */}
                <i
                  onClick={(event) => {
                    openMenu();
                    setActiveProject({
                      ...item,
                    });
                    setXPosition(event.clientX - 122);
                    setYPosition(event.clientY);
                    // setSearchText("");
                  }}
                  style={{
                    alignSelf: "center",
                    cursor: "pointer",
                    marginLeft: "auto",
                    marginRight: "20px",
                  }}
                  className="fa fa-ellipsis-v rowIcon"
                ></i>
              </div>
              {tableRowMenu && projectHover === item.projectId ? (
                <div
                  onMouseLeave={() => {
                    setTableRowMenu(false);
                  }}
                  style={{
                    position: "absolute",
                    backgroundColor: style.colors.white,
                    border: "1px solid grey",
                    left: xPosition,
                    top: yPosition,
                    zIndex: 3,
                  }}
                >
                  <ul
                    style={{
                      listStyle: "none",
                      marginTop: "0px",
                      marginBottom: "0px",
                      width: "80px",
                    }}
                  >
                    <li className="TableRowMenuItems">
                      <span>Open</span>
                    </li>
                    <li className="TableRowMenuItems">
                      <span>Delete</span>
                    </li>
                    <li className="TableRowMenuItems">
                      <span>Export</span>
                    </li>
                    <li className="TableRowMenuItems">
                      <span>Share</span>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  activeProject: state.projects.activeProject,
  style: state.local.style,
  allUsers: state.data.allUsers,
});

export default connect(mapStateToProps, {
  setActiveProject,
  updateRecent,
  addFavorite,
  editProject,
  saveAs,
  deleteProject,
})(Table) as any;
